import React, { useState } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { createPin, showPin } from '~/config/routes';
import Request from '~/providers/Request';
import PinRecord from '~/records/PinRecord';
import Form from './Form';

function NewRecord({ history }) {
  const [record, setRecord] = useState(new PinRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit(saveAndContinue) {
    const data = record.toParams();

    Request.post('/admin/pins', data, {}, { controller: 'pins' })
      .then((resp) => {
        setLoading(false);
        if (saveAndContinue) {
          history.push(createPin.spec);
        } else {
          history.push(showPin.reverse(resp.data));
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes = {
  history: historyPropType,
};

export default NewRecord;
